import React from "react";
import { Link } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/loginReducer';

const Header = () => {
	const { isLoggedIn, user } = useSelector((state) => state.login);
	const cartItems = useSelector((state) => state.cartItems);

	const dispatch = useDispatch();
	const userlogout = () => {
		dispatch(logout());
	};

	// const capitalizeFirstLetter = (name) => {
	// 	if (!name) return '';
	// 	return name.charAt(0).toUpperCase() + name.slice(1);
	// };

	return (
		<div className="top-header-area" id="sticker">
			<div className="container">
				<div className="row">
					<div className="col-lg-12 col-sm-12 text-center">
						<div className="main-menu-wrap">
							<div className="site-logo">
								<Link to="/">
									<img src="/assets/img/logo.png" alt="Logo" />
								</Link>
							</div>
							<nav className="main-menu">
								<ul>
									<li className="current-list-item">
										<Link to="/">Home</Link>

									</li>
									<li><Link to="/">About</Link></li>
									<li>
										<Link to="/">News</Link>

									</li>
									<li><Link to="/">Contact</Link></li>
									<li>
										<div className="header-icons">
											<Link className="shopping-cart" to="/cart">
												<i className="fas fa-shopping-cart"></i> {cartItems?.length || 0}
											</Link>
											<div className="dropdown">
												<button
													className="btn btn-secondary dropdown-toggle"
													type="button"
													id="dropdownMenu2"
													data-bs-toggle="dropdown"
													aria-expanded="false"
												>
													<i className="fas fa-user"></i> &nbsp; {isLoggedIn && user?.name}
												</button>
												<ul className="dropdown-menu custom-dropdown-menu" aria-labelledby="dropdownMenu2">
													{isLoggedIn ? (
														<>
														<li>
																<Link to="/account/orders" className="dropdown-item">
																	My Orders
																</Link>
															</li>
														
															<li>
																<button
																	className="dropdown-item"
																	type="button"
																	onClick={userlogout}
																>
																	Logout
																</button>
															</li>
														</>
													) : (
														<>
															<li>
																<Link to="/account/signup" className="dropdown-item">
																	Signup
																</Link>
															</li>
															<li>
																<Link to="/account/signin" className="dropdown-item">
																	Signin
																</Link>
															</li>
														</>
													)}
												</ul>
											</div>

										</div>
									</li>
								</ul>
							</nav>
							<div className="mobile-menu"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
